import {
  GET_AUTH,
  GET_AUTH_SUCCESS,
  GET_AUTH_FAILURE,
  GET_MACAROON,
  GET_MACAROON_SUCCESS,
  GET_MACAROON_FAILURE,
  GET_USER_AUTH,
  GET_USER_AUTH_SUCCESS,
  GET_USER_AUTH_FAILURE,
  SET_AUTH_STATUS,
  SET_FORCE_AUTHENTICATION,
  SET_PERMS_ERROR,
  SET_ACCOUNT_PERMS,
  SET_ACCOUNT_INDEX,
  CHECK_SAFE_CONNECTIONS,
  CHECK_SAFE_CONNECTIONS_SUCCESS,
} from '../actions/auth';

import { getCollectionsState, getPaymentSetupState } from '../helpers/payments';

export const INITIAL_STATE = () => {
  const locationInfo = {
    query: window.location.search,
    path: window.location.pathname,
  };

  const state = {
    loading: true,
    ...getCollectionsState(locationInfo),
    ...getPaymentSetupState(locationInfo),
  };

  return state;
};

export default function authReducer(state = INITIAL_STATE(), action) {
  switch (action.type) {
    case GET_AUTH:
      return {
        ...state,
        loading: action.showLoading,
        promise: action.payload,
      };
    case SET_ACCOUNT_PERMS:
      return {
        ...state,
        accountPerms: action.payload,
      };
    case GET_AUTH_SUCCESS:
      if (state.crsId) {
        return {
          ...state,
          loading: false,
          error: false,
          crs: action.payload,
          macaroon: false,
        };
      }

      return {
        ...state,
        loading: false,
        error: false,
        macaroon: action.payload,
        crs: false,
        crsId: false,
      };
    case GET_AUTH_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        errorData: action.payload,
        macaroon: false,
        crs: false,
        crsId: false,
      };
    case SET_AUTH_STATUS:
      return {
        ...state,
        status: action.payload,
      };
    case SET_FORCE_AUTHENTICATION:
      return {
        ...state,
        redirect: true,
      };
    case SET_ACCOUNT_INDEX:
      return { ...state, accountIndex: action.payload };
    case CHECK_SAFE_CONNECTIONS:
      return {
        ...state,
        xmAccount: {
          loading: true,
        },
      };
    case CHECK_SAFE_CONNECTIONS_SUCCESS:
      return {
        ...state,
        xmAccount: {
          loading: false,
          ...action.payload,
        },
      };
    case SET_PERMS_ERROR:
      return {
        ...state,
        permsError: true,
        loading: false,
      };
    case GET_MACAROON:
      return {
        ...state,
        loading: action.showLoading,
        promise: action.payload,
      };
    case GET_MACAROON_SUCCESS:
      if (state.crsId) {
        return {
          ...state,
          loading: false,
          error: false,
          crs: action.payload,
          macaroon: false,
        };
      }
      return {
        ...state,
        loading: false,
        error: false,
        macaroon: action.payload,
        crs: false,
        crsId: false,
      };
    case GET_MACAROON_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        errorData: action.payload,
        macaroon: false,
        crs: false,
        crsId: false,
      };
    case GET_USER_AUTH:
      return {
        ...state,
        loading: action.showLoading,
        promise: action.payload,
      };
    case GET_USER_AUTH_SUCCESS:
      if (state.crsId) {
        return {
          ...state,
          loading: false,
          error: false,
          crs: action.payload,
        };
      }
      return {
        ...state,
        loading: false,
        error: false,
        crs: false,
        crsId: false,
      };
    case GET_USER_AUTH_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        errorData: action.payload,
        user: false,
        crs: false,
        crsId: false,
      };
    default:
      return state;
  }
}
